export function getBadgeColor(status: string) {
  let color = "" as
    | "primary"
    | "zinc"
    | "yellow"
    | "red"
    | "emerald"
    | "blue"
    | "indigo"
    | "fuchsia"
    | "orange"
    | "amber"
    | "rose"
    | "pink"
    | "sky"
    | "cyan"
    | "green";

  switch (status) {
    case "DEFAULT":
      color = "zinc";
      break;
    case "DRAFT":
      color = "zinc";
      break;
    case "SENT":
      color = "blue";
      break;
    case "VIEWED":
      color = "fuchsia";
      break;
    case "VOID":
      color = "zinc";
      break;
    case "PAID":
      color = "green";
      break;
    case "UNPAID":
      color = "red";
      break;
    case "OVERDUE":
      color = "red";
      break;
    case "PENDING":
      color = "red";
      break;
    case "APPLIED":
      color = "green";
      break;
    case "PARTIALLY_APPLIED":
      color = "amber";
      break;
    case "PARTIALLY_PAID":
      color = "amber";
      break;
    case "ACCEPTED":
      color = "green";
      break;
    case "ACCEPT":
      color = "green";
      break;
    case "REJECTED":
      color = "red";
      break;
    case "REJECT":
      color = "red";
      break;
    case "QUOTE_AVAILABLE":
      color = "green";
      break;
    case "buyer":
      color = "indigo";
      break;
    case "supplier":
      color = "fuchsia";
      break;
    case "ACTIVE":
      color = "green";
      break;
    case "INACTIVE":
      color = "zinc";
      break;
    case "active":
      color = "green";
      break;
    case "inactive":
      color = "zinc";
      break;
    case "owes":
      color = "red";
      break;
    case "credits":
      color = "green";
      break;
    case "PROCESSING":
      color = "amber";
      break;
    case "PROCESSED":
      color = "green";
      break;
    case "EXPIRED":
      color = "zinc";
      break;
    case "COMPLETED":
      color = "green";
      break;
    case "IN STOCK":
      color = "green";
      break;
    case "LOW STOCK":
      color = "yellow";
      break;
    case "successful":
      color = "green";
      break;
    case "OUT OF STOCK":
      color = "red";
      break;
    case "pending_approval":
      color = "orange";
      break;
    default:
      color = "blue";
  }
  return color;
}
